import { formatChatDate } from '@utils/index';
import { SenderType } from '../../../../types/chat-message';

export type MessageGroupPosition = 'single' | 'first' | 'middle' | 'last';

export interface GroupableMessage {
  user?: SenderType | string;
  senderType?: SenderType | string;
  time?: string;
  createdAt?: string;
  [key: string]: any;
}

export const getSender = (msg?: GroupableMessage | null): string | undefined => {
  if (!msg) return undefined;
  return (msg.user || msg.senderType) as string | undefined;
};

export const isSameSenderGroup = (
  msgA?: GroupableMessage | null,
  msgB?: GroupableMessage | null,
): boolean => {
  if (!msgA || !msgB) return false;
  const senderA = getSender(msgA);
  const senderB = getSender(msgB);
  return Boolean(senderA && senderB && senderA === senderB);
};

export const isDateDividerBefore = (log: GroupableMessage[], idx: number): boolean => {
  if (!log || idx <= 0 || idx >= log.length) return false;
  const currTime = log[idx]?.time || log[idx]?.createdAt;
  const prevTime = log[idx - 1]?.time || log[idx - 1]?.createdAt;
  const curr = formatChatDate(currTime);
  const prev = formatChatDate(prevTime);
  return Boolean(curr && curr !== prev);
};

export const getMessageGroupPosition = (
  messages: GroupableMessage[],
  index: number,
  checkDivider: (idx: number) => boolean = (idx) => isDateDividerBefore(messages, idx),
): MessageGroupPosition => {
  if (!messages || index < 0 || index >= messages.length) return 'single';
  const hasPrev = index > 0 && !checkDivider(index) && isSameSenderGroup(messages[index], messages[index - 1]);
  const hasNext = index < messages.length - 1 && !checkDivider(index + 1) && isSameSenderGroup(messages[index], messages[index + 1]);
  if (!hasPrev && !hasNext) return 'single';
  if (!hasPrev && hasNext) return 'first';
  if (hasPrev && hasNext) return 'middle';
  return 'last';
};

export const getMessageSpacingClass = (
  hasPrevSameSender: boolean,
  isFirstMessage: boolean,
  hasDateDivider: boolean,
): string => {
  if (isFirstMessage || hasDateDivider) return '';
  return hasPrevSameSender ? 'mt-[2px]' : 'mt-[16px]';
};
